import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './FarmerSignupPage.module.css';
import { NamedLink } from '../../components';

export const FarmerSignupPageComponent = props => {
  // const { pageAssetsData, inProgress, error } = props;

  return (
    <div 
      className={css.FarmerSignupPage}
      style={{
        backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
      }}
    >
      <TopbarContainer />

      <div className={css.root}>
        <div className={css.contentWrapper}>
          <h1 className={css.title}>Join as a Farmiez Farmer 🐓</h1>
          <p className={css.intro}>
            Ready to share your fresh, local goods with the community? Sign up as a Farmiez Farmer
            to create your own storefront, list your products, and connect with nearby shoppers.
          </p>
          <NamedLink name="SignupPage" className={css.customBtn}>
            🐓 Join the Coop
          </NamedLink>
        </div>
      </div>
      
      <FooterContainer />
    </div>
  );
};

FarmerSignupPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  // const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  // return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const FarmerSignupPage = compose(connect(mapStateToProps))(FarmerSignupPageComponent);

export default FarmerSignupPage;
